module.exports = __webpack_public_path__ + "img/camera-x.5690672f.svg";